/* cc-variant-filter — see snippets/cc-variant-filter.liquid.
   For option group i>0, a value is visible only if some variant pairs
   it with ALL selected earlier options. If the selected value becomes
   hidden, auto-select the group's first visible value and dispatch
   change (runs through Dawn's normal pipeline). Uses Dawn's pub-sub
   (subscribe/PUB_SUB_EVENTS from global scope; we load after
   constants/pubsub like every cc- script). */

(() => {
  const productInfo = document.querySelector("product-info[id^='MainProduct']");
  const dataEl = document.getElementById('cc-variant-filter-data');
  if (!productInfo || !dataEl) return;

  let combos;
  try {
    combos = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!Array.isArray(combos) || !combos.length) return;

  let dispatching = false;

  const apply = () => {
    const selects = productInfo.querySelector('variant-selects');
    if (!selects) return;
    const groups = Array.from(selects.querySelectorAll('.product-form__input'));

    const selected = groups.map((g) => {
      const checked = g.querySelector("input[type='radio']:checked");
      if (checked) return checked.value;
      return g.querySelector('select')?.value ?? null;
    });

    groups.forEach((group, i) => {
      if (i === 0) return; // first option: always all values

      const exists = (value) =>
        combos.some(
          (opts) => opts[i] === value && opts.slice(0, i).every((o, q) => o === selected[q])
        );

      let selectionHidden = false;

      group.querySelectorAll("input[type='radio']").forEach((input) => {
        const show = exists(input.value);
        input.style.display = show ? '' : 'none';
        const label = group.querySelector(`label[for='${input.id}']`);
        if (label) label.style.display = show ? '' : 'none';
        if (!show && input.checked) selectionHidden = true;
      });

      group.querySelectorAll('select option').forEach((opt) => {
        const show = exists(opt.value);
        opt.hidden = !show;
        if (!show && opt.selected) selectionHidden = true;
      });

      if (selectionHidden && !dispatching) {
        const firstVisible =
          Array.from(group.querySelectorAll("input[type='radio']")).find(
            (r) => r.style.display !== 'none'
          ) ||
          Array.from(group.querySelectorAll('select option')).find((o) => !o.hidden);
        if (firstVisible) {
          dispatching = true;
          if (firstVisible.tagName === 'INPUT') {
            firstVisible.checked = true;
            firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const sel = group.querySelector('select');
            sel.value = firstVisible.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          setTimeout(() => (dispatching = false), 400);
        }
      }
    });
  };

  apply();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    // variant-selects is REPLACED on every change — re-filter the fresh DOM
    subscribe(PUB_SUB_EVENTS.variantChange, () => apply());
    // Dawn does NOT publish variantChange when a selection resolves to a
    // nonexistent combo (setUnavailable early-returns) but it still
    // re-renders the picker — re-apply after the fetch settles too.
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      setTimeout(apply, 500);
      setTimeout(apply, 1200); // slow-network belt
    });
  }
})();
